// extracted by mini-css-extract-plugin
module.exports = {"PartnerEvents":"PartnerEvents-module--PartnerEvents--3Sqe2","Heading":"PartnerEvents-module--Heading--34WA2"};